import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c3636b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Meetings")
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center ion-padding"
}
const _hoisted_3 = {
  key: 1,
  class: "ion-text-center ion-padding empty-state"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-title" }, "Nessun meeting disponibile", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-subtitle" }, "Torna più tardi per nuovi contenuti.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("NUOVO")
const _hoisted_8 = { class: "lesson-title-row" }
const _hoisted_9 = {
  key: 0,
  class: "lesson-description"
}
const _hoisted_10 = { class: "lesson-footer" }
const _hoisted_11 = { class: "lesson-meta" }
const _hoisted_12 = ["onClick"]

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonRefresher,
  IonRefresherContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonSpinner,
  IonBadge,
  IonImg,
  IonChip,
  IonLabel,
  IonIcon,
  IonCardSubtitle,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/vue';
import {computed, ref} from 'vue';
import {
  calendarOutline,
  layersOutline,
  personOutline,
  schoolOutline,
  timeOutline,
  arrowForwardOutline,
} from 'ionicons/icons';
import LessonsService from '@/api/lessons/LessonsService';
import MeetingsService from '@/api/meetings/MeetingsService';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { fetchLessons, getCurrentLessons } = LessonsService();
const { joinMeeting } = MeetingsService();

const isLoading = ref(false);
const isJoining = ref(false);

const lessons = computed(() => {
  const currentLessons = getCurrentLessons() || [];
  return [...currentLessons].sort((firstLesson, secondLesson) => {
    const firstStart = firstLesson && firstLesson.start ? firstLesson.start : 0;
    const secondStart = secondLesson && secondLesson.start ? secondLesson.start : 0;
    return firstStart - secondStart;
  });
});
const hasLessons = computed(() => lessons.value.length > 0);

const isLessonJoinable = lesson => {
  if (!lesson || !lesson.start || !lesson.end) {
    return false;
  }
  const nowMs = Date.now();
  const startMs = lesson.start * 1000;
  const endMs = lesson.end * 1000;
  const windowMs = 15 * 60 * 1000;
  return nowMs >= startMs - windowMs && nowMs <= endMs + windowMs;
};

const formatLessonDay = (timestamp: number) => {
  if (!timestamp) {
    return '';
  }
  const date = new Date(timestamp * 1000);
  return new Intl.DateTimeFormat('it-IT', {
    dateStyle: 'medium',
  }).format(date);
};

const formatLessonTime = (timestamp: number) => {
  if (!timestamp) {
    return '';
  }
  const date = new Date(timestamp * 1000);
  return new Intl.DateTimeFormat('it-IT', {
    timeStyle: 'short',
  }).format(date);
};

const loadLessons = async () => {
  isLoading.value = true;
  try {
    await fetchLessons();
  } finally {
    isLoading.value = false;
  }
};

loadLessons();

const handleEnterLesson = async lesson => {
  if (!lesson || !lesson.id || !isLessonJoinable(lesson)) {
    return;
  }
  if (isJoining.value) {
    return;
  }
  isJoining.value = true;
  try {
    const response = await joinMeeting(lesson.id);
    const joinUrl = response
        && response.data
        && response.data.data
        && response.data.data.url
        && response.data.data.url.join_url;
    if (joinUrl) {
      window.open(joinUrl, '_blank');
    }
  } finally {
    isJoining.value = false;
  }
};

const doRefresh = (event: any) => {
  loadLessons();
  setTimeout(() => {
    if (event && event.target) {
      event.target.complete();
    }
  }, 2000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent))
            ]),
            _: 1
          }),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(IonSpinner), { name: "crescent" })
              ]))
            : (!_unref(hasLessons))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : (_openBlock(), _createBlock(_unref(IonGrid), {
                  key: 2,
                  class: "lessons-list"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lessons), (lesson) => {
                          return (_openBlock(), _createBlock(_unref(IonCol), {
                            key: lesson.id,
                            size: "12",
                            "size-md": "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCard), {
                                class: _normalizeClass(["lesson-card", { 'is-clickable': isLessonJoinable(lesson) }]),
                                onClick: ($event: any) => (handleEnterLesson(lesson))
                              }, {
                                default: _withCtx(() => [
                                  (lesson.new || lesson.is_new)
                                    ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                        key: 0,
                                        color: "danger",
                                        class: "lesson-badge"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_7
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (lesson.cover || lesson.image)
                                    ? (_openBlock(), _createBlock(_unref(IonImg), {
                                        key: 1,
                                        src: lesson.cover || lesson.image,
                                        class: "lesson-cover"
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_unref(IonCardHeader), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_unref(IonCardTitle), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(lesson.title || lesson.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      (lesson.subtitle || lesson.subject)
                                        ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(lesson.subtitle || lesson.subject), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonCardContent), null, {
                                    default: _withCtx(() => [
                                      (lesson.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(lesson.description), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                          (lesson.teacher || lesson.author)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 0,
                                                color: "primary",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(personOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(lesson.teacher || lesson.author), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (lesson.start && lesson.end)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 1,
                                                color: "medium",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(calendarOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(formatLessonDay(lesson.start)) + " " + _toDisplayString(formatLessonTime(lesson.start)) + " - " + _toDisplayString(formatLessonTime(lesson.end)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (lesson.level)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 2,
                                                color: "secondary",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(schoolOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(lesson.level), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (lesson.duration)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 3,
                                                color: "tertiary",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(timeOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(lesson.duration), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (lesson.date)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 4,
                                                color: "medium",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(calendarOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(lesson.date), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (lesson.category)
                                            ? (_openBlock(), _createBlock(_unref(IonChip), {
                                                key: 5,
                                                color: "success",
                                                outline: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonIcon), { icon: _unref(layersOutline) }, null, 8, ["icon"]),
                                                  _createVNode(_unref(IonLabel), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(lesson.category), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["lesson-cta", { 'lesson-cta--disabled': isJoining.value || !isLessonJoinable(lesson) }]),
                                          onClick: _withModifiers(($event: any) => (handleEnterLesson(lesson)), ["stop"])
                                        }, [
                                          (isJoining.value)
                                            ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                                                key: 0,
                                                name: "crescent",
                                                class: "join-spinner"
                                              }))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", null, _toDisplayString(isJoining.value ? 'Apertura in corso...' : 'Entra'), 1),
                                          (!isJoining.value)
                                            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                                key: 1,
                                                icon: _unref(arrowForwardOutline),
                                                class: "lesson-cta-icon"
                                              }, null, 8, ["icon"]))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_12)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})